import type { ReportOptionItem } from '@/core/models/report-options.models';

const SMALL_COMPANY = 'SMALL';
const MEDIUM_COMPANY = 'MEDIUM';
const FRS105 = 'FRS105';
const FRS102_1A = 'FRS102_1A';

const same = (a: string | null | undefined, b: string) => (a ?? '').trim().toUpperCase() === b;

/** The taxonomies a size is not offered (Testing Flows: Micro -> FRS 105, Small -> FRS 102 1A / 102, Medium -> full FRS 102). */
function notOffered(companySize: string | null | undefined): string[] {
  if (same(companySize, SMALL_COMPANY)) return [FRS105];
  if (same(companySize, MEDIUM_COMPANY)) return [FRS105, FRS102_1A];
  return [];
}

/**
 * Use Taxonomy choices for the company size on the form. FRS 105 is the micro-entity regime, so a Small company is not
 * offered it (issue #8), and FRS 102 Section 1A is for small entities, so a Medium company gets neither. A company that
 * already holds a taxonomy keeps it in the list: the field would otherwise go blank, and nothing here changes a saved value.
 */
export function taxonomyChoices(
  taxonomies: ReportOptionItem[],
  companySize: string | null | undefined,
  currentTaxonomy: string | null | undefined,
): ReportOptionItem[] {
  const hidden = notOffered(companySize);
  if (hidden.length === 0) return taxonomies;
  return taxonomies.filter(
    (item) => !hidden.some((code) => same(item.code, code)) || same(currentTaxonomy, item.code.trim().toUpperCase()),
  );
}
